import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49582c6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal-size-min max-w-screen-lg box-border px-8 pt-4 pb-8 m-4 text-gray-800 dark:text-dark-text",
  style: {"user-select":"none"}
}
const _hoisted_2 = { class: "flex mt-2 ml-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons my-auto text-2xl" }, "reviews", -1))
const _hoisted_4 = { class: "text-2xl pl-1 border-gray-400 dark:border-dark-200" }
const _hoisted_5 = {
  key: 0,
  class: "py-12 bg-white dark:bg-dark-900",
  style: {"position":"relative"}
}
const _hoisted_6 = {
  key: 1,
  class: "mt-6"
}
const _hoisted_7 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_8 = { class: "mt-4 flex items-center justify-center" }
const _hoisted_9 = {
  class: "text-base",
  style: {"width":"98%"}
}
const _hoisted_10 = {
  class: "border border-gray-300 bg-gray-200 dark:border-dark-400 dark:bg-dark-500",
  style: {"padding":"2px 12px 2px 12px","border-radius":"1rem 1rem 0 0"}
}
const _hoisted_11 = { class: "text-gray-800 dark:text-dark-text" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "px-4 ml-6 flex mb-8",
  style: {"user-select":"contain"}
}, [
  /*#__PURE__*/_createElementVNode("ul", { class: "list-disc" }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "hover:underline text-blue-500",
        href: "https://openai.com/ja-JP/policies/terms-of-use/",
        target: "_blank"
      }, " ChatGPT ")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "hover:underline text-blue-500",
        href: "https://support.google.com/gemini/answer/13594961?hl=ja",
        target: "_blank"
      }, " Gemini ")
    ])
  ])
], -1))
const _hoisted_15 = { class: "flex items-center justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OutlinedIconTextButton = _resolveComponent("OutlinedIconTextButton")!
  const _component_InputArea = _resolveComponent("InputArea")!
  const _component_IconTextButton = _resolveComponent("IconTextButton")!
  const _component_PrimaryModal = _resolveComponent("PrimaryModal")!

  return (_openBlock(), _createBlock(_component_PrimaryModal, { onClickBackground: _ctx.onClose }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('message.review')), 1)
        ]),
        (_ctx.reviewRequestPresenter.isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.isLightMode() ? 'loading' : 'loading-dark')
              }, null, 2)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_ctx.requestList != undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_OutlinedIconTextButton, {
                        key: item.id,
                        class: "mx-2 my-2",
                        icon: _ctx.checkedList[index] ? 'radio_button_checked' : 'radio_button_unchecked',
                        iconSize: 'text-2xl',
                        padding_bottom: 2,
                        padding_left: 2,
                        padding_right: 2,
                        padding_top: 2,
                        style: _normalizeStyle({
              backgroundColor: _ctx.getBackgroundColor(index, _ctx.requestList.length)
            }),
                        text: item.message,
                        onClick: ($event: any) => (_ctx.checkRequestItem(index))
                      }, null, 8, ["icon", "style", "text", "onClick"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('message.freeDescription')), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_InputArea, {
                class: "shadow-md border border-gray-300 text-gray-800 dark:border-dark-400 dark:text-dark-text dark:bg-dark-400",
                isEditable: true,
                onChange: _ctx.reviewRequestPresenter.setFreeDescription,
                style: {"height":"160px","border-radius":"0 0 1rem 1rem"},
                value: _ctx.reviewRequestPresenter.freeDescription.value,
                width: '100%'
              }, null, 8, ["onChange", "value"])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "px-4 flex mt-6 mb-2 text-red-600 dark:text-red-400",
          style: {"user-select":"contain"},
          innerHTML: _ctx.aiAlertStr
        }, null, 8, _hoisted_13),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_IconTextButton, {
            border_radius: 1,
            class: "mr-2 mt-1 mb-4",
            icon: 'send',
            iconSize: 'text-xl',
            padding_bottom: 4,
            padding_left: 10,
            padding_right: 10,
            padding_top: 4,
            text: _ctx.$t('message.requestReview'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requestReview()))
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClickBackground"]))
}